import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Context } from '../ContextProvider';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import Title from './Title';
const dayjs = require('dayjs');

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-content',
  height: 'fit-content',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 2,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export default function ExportData({ data }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { state, stateTransactions } = React.useContext(Context);
  const [exitColor, setExitColor] = React.useState('white');

  function exportCSV(gd) {
    let text = `Month, ${gd.name} \n`;
    for (let i = 0; i < gd.x.length; i++) {
      text += `${gd.x[i]}, ${gd.y[i]} \n`;
    }

    let blob = new Blob([text], { type: 'text/plain' });
    let a = document.createElement('a');
    const object_URL = URL.createObjectURL(blob);
    a.href = object_URL;
    a.download = `${gd.name}.csv`;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(object_URL);
  }

  return (
    <div>
      <Button
        onClick={handleOpen}
        fullWidth
        variant="contained"
        style={{
          width: 'fit-content',
          height: '1.5rem',
          marginRight: '0.5rem',
        }}
      >
        Export Data
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box id="scenarios" sx={style}>
            <IconButton
              onClick={() => setOpen(false)}
              id="x"
              onMouseEnter={() => setExitColor('red')}
              onMouseLeave={() => setExitColor('white')}
              style={{
                color: exitColor,
              }}
            >
              <CloseIcon />
            </IconButton>
            <div
              id="scenarios"
              className="display-column"
              style={{
                overflow: 'scroll',
                alignItems: 'center',
                width: '65vw',
              }}
            >
              {data?.map((set) => (
                <div className="display-row" style={{ marginBottom: '1rem' }}>
                  <Button
                    variant="outlined"
                    onClick={() => exportCSV(set)}
                  >{`Export ${set.name} to CSV`}</Button>
                </div>
              ))}
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
